module.exports = __webpack_public_path__ + "static/media/celular.d915f7ad.svg";